import React, { PureComponent } from "react";

import homeImage from "./home-image.jpg";
import facebookLogo from "./facebook-logo.svg";

class HomePage extends PureComponent {
  render() {
    return (
      <div>
        <h1>Mark Allan</h1>

        <div
          style={{
            margin: 10
          }}
        >
          <h2>Producer, engineer, bass player, singer.</h2>

          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center"
            }}
          >
            <div>
              <a
                href="https://www.facebook.com/mark.a.courtney"
                target="_blank"
                rel="noopener noreferrer"
              >
                Contact me via Facebook
              </a>
            </div>
            <div>
              <a
                href="https://www.facebook.com/mark.a.courtney"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  style={{
                    width: 32,
                    margin: 5
                  }}
                  alt="Facebook logo"
                  src={facebookLogo}
                />
              </a>
            </div>
          </div>

          <div>
            <img
              alt="Mark Allan"
              src={homeImage}
              style={{
                width: "100%",
                height: "auto",
                maxWidth: "100%"
              }}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default HomePage;



// WEBPACK FOOTER //
// ./src/routes/home/HomePage.js